import { DataManager } from "../../../data/model/DataManager.js";
import { DataEndpoint } from "../../../data/remote/DataEndpoint";

export class AccountDataManager extends DataManager {

    constructor(authManager) {

        super(new DataEndpoint('/core/account', authManager));

    }

    /**
        * 
        * @param {object} data - { username, password, passwordVerification, email, firstName, lastName }
        * @returns Call promise.
        */
    registerUser(data) {

        return this.getDataEndpoint().post('/register', data, { anonymous: true });

    };

    /**
     * 
     * @param {object} data - { code }
     * @returns Call promise.
     */
    verifyEmail(data) {

        return this.getDataEndpoint().get('/verify-email', data, { anonymous: true });

    };

    /**
     * 
     * @returns Call promise.
     */
    getDetails() {

        return this.getDataEndpoint().get('');

    };

    /**
     * 
     * @param {object} data - { firstName, lastName }
     * @returns Call promise.
     */
    changeDetails(data) {

        return this.getDataEndpoint().post('', data);

    };

    /**
     * 
     * @param {object} data - { actualPassword, password, passwordVerification }
     * @returns Call promise.
     */
    changePassword(data) {

        return this.getDataEndpoint().post('/change-password', data);

    };

    /**
     * 
     * @param {object} data - { email }
     * @returns Call promise.
     */
    startPasswordReset(data) {

        return this.getDataEndpoint().post('/initialize-password-reset', data, { anonymous: true });

    };

    /**
     * 
     * @param {object} data - { code, password, passwordVerification }
     * @returns Call promise.
     */
    resetPassword(data) {

        return this.getDataEndpoint().post('/reset-password', data, { anonymous: true });

    };

}